import { AdministrationRequestModel } from "./administration.model";

const ACTION_SCOPE = '[Administration]';

export class SetFilteredAdministrations {
    static readonly type = `${ACTION_SCOPE} Set Filtered Administrations`;
    constructor(public payload: string) {}
}
export class SetSearchQuery {
    static readonly type = `${ACTION_SCOPE} Set Search Query`;
    constructor(public query: string) { }
}

// Get all Administrations action
export class Administrations {
    static readonly type = `${ACTION_SCOPE} Get Administrations`
}

// Get single Administration action
export class Administration {
    static readonly type = `${ACTION_SCOPE} Get Administration`
    constructor(public payload: string) { }
}

export class GetSingleAdminstration {
  static readonly type = `${ACTION_SCOPE} Get Single Administration`
  constructor(public payload: string) { }
}

// Add Create Administration action
export class CreateAdministration {
    static readonly type = `${ACTION_SCOPE} Create Administration`;
    constructor(public payload: Omit<AdministrationRequestModel, 'id'>) { }
}

// Add Update Administration action
export class UpdateAdministration {
    static readonly type = `${ACTION_SCOPE} Update Administration`;
    constructor(public payload: AdministrationRequestModel) { }
}

// Add Delete Administration action
export class DeleteAdministration {
    static readonly type = `${ACTION_SCOPE} Delete Administration`;
    constructor(public payload: string) { }  // payload is the Administration ID
}

export class AssignModerators {
  static readonly type = `${ACTION_SCOPE} Assign Moderators to Administration`;
  constructor(public payload: any) { }
}

export class AssignInterviewers {
  static readonly type = `${ACTION_SCOPE} Assign Interviewers to Administration`;
  constructor(public payload: any) { }
}

export class AssignInterviewees {
  static readonly type = `${ACTION_SCOPE} Assign Applicants to Administration`;
  constructor(public payload: any) { }
}
